module.exports = __webpack_public_path__ + "static/media/clubdenuitman.86d79f55.png";